export default __webpack_public_path__ + "static/media/arras12.eedd79f2.jpg";